import {consentPromise, UserCentricIds} from "@utilities/sal-usercentrics/sal-usercentrics";

const API_KEY = window.gmaps_api_key;
//const API_KEY = '';
const CALLBACK_NAME = 'gmapsCallback';

let initialized = !!window.google;
let resolveInitPromise;
let rejectInitPromise;

const initPromise = new Promise((resolve, reject) => {
    resolveInitPromise = resolve;
    rejectInitPromise = reject;
});

export default function init() {
    // If Google Maps already is initialized
    // the `initPromise` should get resolved
    // eventually.
    if (initialized) return initPromise;

    initialized = true;
    // The callback function is called by
    // the Google Maps script if it is
    // successfully loaded.
    window[CALLBACK_NAME] = () => resolveInitPromise(window.google);

    consentPromise(UserCentricIds.GOOGLE_MAPS).then(() => {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}`;
        script.onerror = rejectInitPromise;
        document.querySelector('head').appendChild(script);
    });
    return initPromise;
}
